import {
  AICommand,
  AudioBlock,
  BlockquoteFigure,
  CharacterCount,
  Color,
  Document,
  Dropcursor,
  Facebook,
  Figcaption,
  FileHandler,
  Focus,
  FontFamily,
  FontSize,
  Heading,
  Highlight,
  HorizontalRule,
  LinkPreview,
  ImageBlock,
  InsideLinks,
  Instagram,
  Link,
  Linkedin,
  Paragraph,
  PasteHandler,
  Placeholder,
  Selection,
  SlashCommand,
  StarterKit,
  Subscript,
  Superscript,
  Table,
  TableCell,
  TableHeader,
  TableRow,
  TaskItem,
  TaskList,
  TextAlign,
  TextStyle,
  Tiktok,
  TrailingNode,
  Twitter,
  Typography,
  Underline,
  VideoBlock,
  Youtube,
  Iframe,
  BulletList,
} from './index.js'

import { ImageUpload } from './ImageUpload/ImageUpload.js'

import History from '@tiptap/extension-history'
import { Markdown } from 'tiptap-markdown'
import API from '../lib/api.js'
import { openAssetHQType } from '../types.js'
import i18next from 'i18next'
import { getAssetActualSize } from './ImageUpload/getImageActualSize.js'

interface ExtensionKitProps {
  openAssetHQHandler: openAssetHQType
  dir?: 'ltr' | 'rtl'
}

export const ExtensionKit = ({ dir = 'ltr', openAssetHQHandler }: ExtensionKitProps) => [
  Markdown,
  Document,
  TaskList,
  TaskItem.configure({
    nested: true,
  }),
  Selection,
  Heading.configure({
    levels: [1, 2, 3, 4, 5, 6],
  }),
  HorizontalRule,
  StarterKit.configure({
    document: false,
    dropcursor: false,
    heading: false,
    horizontalRule: false,
    blockquote: false,
    history: false,
    codeBlock: false,
    paragraph: false,
  }),
  Paragraph,
  TextStyle,
  // FontSize,
  // FontFamily,
  // Color,
  // TrailingNode,
  Link.configure({
    openOnClick: false,
  }),
  // Highlight.configure({ multicolor: true }),
  Underline,
  CharacterCount.configure({ limit: 50000 }),
  ImageUpload.configure({
    openAssetHQHandler,
  }),
  ImageBlock,
  VideoBlock,
  AudioBlock,
  FileHandler.configure({
    allowedMimeTypes: ['image/png', 'image/jpeg', 'image/gif', 'image/webp'],
    onDrop: (currentEditor, files, pos) => {
      const file = files[0]
      ;(async () => {
        openAssetHQHandler(
          (asset) => {
            let title = asset.title
            if (i18next.language !== 'en' && !!asset.title_locale[i18next.language.toUpperCase()]) {
              title = asset.title_locale[i18next.language.toUpperCase()]
            }
            const { actualHeight, actualWidth } = getAssetActualSize(asset)
            currentEditor
              .chain()
              .setImageBlockAt({
                pos,
                src: asset?.optimizedImageUrl || asset.fullUrl,
                caption: title,
                actualHeight,
                actualWidth,
              })
              .focus()
              .run()
          },
          file,
          'image',
        )
      })()
    },
    onPaste: (currentEditor, files) => {
      files.forEach(async () => {
        const url = await API.uploadImage()

        return currentEditor
          .chain()
          .setImageBlockAt({
            pos: currentEditor.state.selection.anchor,
            src: url,
          })
          .focus()
          .run()
      })
    },
  }),
  // Emoji.configure({
  //   enableEmoticons: true,
  //   suggestion: emojiSuggestion,
  // }),
  TextAlign.extend({
    addKeyboardShortcuts() {
      return {}
    },
  }).configure({
    defaultAlignment: dir === 'rtl' ? 'right' : 'left',
    types: ['heading', 'paragraph'],
  }),
  Subscript,
  Superscript,
  Typography,
  Placeholder.configure({
    includeChildren: true,
    showOnlyCurrent: false,
    placeholder: () => '',
  }),
  SlashCommand,
  Focus,
  Figcaption,
  BlockquoteFigure,
  Dropcursor.configure({
    width: 2,
    class: 'ProseMirror-dropcursor border-black',
  }),
  History,
  Twitter,
  Tiktok,
  Instagram,
  Facebook,
  Linkedin,
  Youtube,
  InsideLinks,
  Iframe,
  AICommand,
  LinkPreview,
  BulletList,
  Table,
  TableRow,
  TableHeader,
  TableCell,
  PasteHandler,
]

export default ExtensionKit
